export const language = {
  en: {
    'Tenders Announcement': 'Tenders Announcement',
    'Tenders Management': 'Tenders Management',
    'My Tenders': 'My Tenders',

   
  },
  zh: {
    "Tenders Announcement": "招标公告",
    "Tenders Management": "招标管理",
    "My Tenders": "我的招标",
  },
};

